module.exports = __webpack_public_path__ + "img/high.c0c6921f.png";